import imageWithCaption from "../objects/imageWithCaption";
import { multilingualArrayBlockContent } from "../base";
import { keyFeatures, shipSections, suiteConfiguration } from "../objects";
import HexColorInput from "../../components/HexColorInput";
import comparableFeatures from "../objects/comparableFeatures";
import suiteCategory from "./suiteCategory";
import { defineField, defineType } from "sanity";

import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  name: "shipSuite",
  title: "Ship Suite",
  type: "object",
  preview: {
    select: {
      title: "category.name",
      imageUrl: "images.0.asset.url"
    },
    prepare({ title }) {
      return { title: multilingualStringPreview(title) };
    }
  },
  fieldsets: [
    {
      name: "deprecated",
      title: "Deprecated (Deprecated)",
      options: {
        collapsible: true,
        collapsed: true
      }
    }
  ],
  groups: [
    { name: "asCard", title: "Render as Card" },
    {
      name: "seo",
      title: "SEO, Routing & Tracking"
    }
  ],
  fields: [
    {
      name: "category",
      title: "Category",
      type: "reference",
      to: [{ type: suiteCategory.name }],
      validation: (Rule) => Rule.required()
    },
    defineField({
      name: "color",
      title: "Color (HEX color code)",
      type: "string",
      components: {
        input: HexColorInput
      }
    }),
    {
      name: "description",
      title: "Description",
      type: multilingualArrayBlockContent.name,
      options: {
        collapsible: true,
        collapsed: true
      }
    },
    {
      name: "configurations",
      title: "Configurations",
      description: "e.g. One bedroom, two bedroom, accessible",
      type: "array",
      of: [
        {
          type: suiteConfiguration.name
        }
      ]
    },
    {
      name: "images",
      title: "Images",
      type: "array",
      of: [{ type: imageWithCaption.name }]
    },
    {
      name: "deck",
      title: "Deck(s))",
      type: "array",
      of: [{ type: "number" }]
    },
    {
      name: "shipSections",
      title: "Ship Sections",
      type: shipSections.name
    },
    {
      name: "keyFeatures",
      title: "Key Features",
      type: keyFeatures.name
    },
    {
      name: "comparableFeatures",
      title: "Comparable Features",
      type: comparableFeatures.name,
      options: {
        collapsible: true,
        collapsed: true
      }
    },
    {
      name: "card",
      title: "Render as Card",
      type: "asCard",
      group: "asCard"
    }
  ]
});
